/* BRIGHTS PREMIUM shared JS: header scroll state, carousels */
(function () {
  'use strict';

  /* ---- Transparent header: solid after scrolling past threshold ---- */
  function initHeader() {
    var header = document.querySelector('.bp-header');
    if (!header || header.dataset.bpInit) return;
    header.dataset.bpInit = '1';
    var threshold = 40;
    var locked = header.classList.contains('bp-header--locked');
    function update() {
      if (locked) return;
      header.classList.toggle('bp-header--solid', window.scrollY > threshold);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();

    var burger = header.querySelector('.bp-header__burger');
    var drawer = document.querySelector('.bp-drawer');
    if (burger && drawer) {
      burger.addEventListener('click', function () {
        var open = drawer.classList.toggle('bp-drawer--open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.classList.toggle('bp-no-scroll', open);
      });
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          drawer.classList.remove('bp-drawer--open');
          document.documentElement.classList.remove('bp-no-scroll');
        });
      });
    }
  }

  /* ---- Generic carousel: dots + arrows, scroll-snap based ---- */
  function initCarousels() {
    document.querySelectorAll('.bp-carousel').forEach(function (root) {
      if (root.dataset.bpInit) return;
      root.dataset.bpInit = '1';
      var track = root.querySelector('.bp-carousel__track');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.bp-carousel__slide'));
      var dotsWrap = root.querySelector('.bp-carousel__dots');
      var prev = root.querySelector('.bp-carousel__arrow--prev');
      var next = root.querySelector('.bp-carousel__arrow--next');
      if (!track || slides.length === 0) return;

      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.className = 'bp-carousel__dot';
          b.type = 'button';
          b.setAttribute('aria-label', 'Slide ' + (i + 1));
          b.addEventListener('click', function () { goTo(i); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      var current = 0;
      function slideLeft(i) {
        return slides[i].offsetLeft - track.offsetLeft;
      }
      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slideLeft(i), behavior: 'smooth' });
      }
      function sync() {
        var x = track.scrollLeft;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(slideLeft(i) - x);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        current = best;
        dots.forEach(function (d, i) {
          d.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
        if (prev) prev.toggleAttribute('disabled', current === 0);
        if (next) next.toggleAttribute('disabled', current === slides.length - 1);
      }
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(sync, 80);
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* Reveal-on-scroll removed 2026-07-16 (matej) — content renders immediately. */

  /* ---- Cart popup: "Dodano u košaricu" ---- */
  /* Valuta iz /cart.js (EUR za HR/SI/ME; od 24. 10. 2026. RSD za Srbiju, BAM za BiH — vidi snippets/bp-money). */
  function bpMoney(cents, currency) {
    var cur = currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    if (cur === 'EUR') return '€' + (cents / 100).toFixed(2).replace('.', ',');
    var n = Math.round(cents), neg = n < 0; n = Math.abs(n);
    var whole = Math.floor(n / 100), rem = n % 100;
    var txt = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (rem ? ',' + (rem < 10 ? '0' : '') + rem : '');
    return (neg ? '−' : '') + txt + (cur === 'RSD' ? ' RSD' : cur === 'BAM' ? ' KM' : ' ' + cur);
  }

  function ensureCartPopup() {
    var pop = document.querySelector('.bp-cart-pop');
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'bp-cart-pop';
    pop.setAttribute('role', 'status');
    pop.innerHTML =
      '<div class="bp-cart-pop__head">' +
        '<p class="bp-cart-pop__title">Dodano u košaricu</p>' +
        '<button class="bp-cart-pop__close" type="button" aria-label="Zatvori">&#10005;</button>' +
      '</div>' +
      '<div class="bp-cart-pop__items"></div>' +
      '<div class="bp-cart-pop__btns">' +
        '<a class="bp-cart-pop__btn bp-cart-pop__btn--cart" href="/cart">Pogledaj košaricu</a>' +
        '<a class="bp-cart-pop__btn bp-cart-pop__btn--checkout" href="/checkout">Naruči</a>' +
      '</div>';
    document.body.appendChild(pop);
    pop.querySelector('.bp-cart-pop__close').addEventListener('click', function () {
      pop.classList.remove('bp-cart-pop--open');
    });
    return pop;
  }

  function showCartPopup() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pop = ensureCartPopup();
        var list = pop.querySelector('.bp-cart-pop__items');
        list.innerHTML = cart.items.map(function (i) {
          var img = i.image ? i.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_120x120$1$2') : '';
          return '<div class="bp-cart-pop__item">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
            '<div class="bp-cart-pop__item-info">' +
              '<span class="bp-cart-pop__item-title">' + i.product_title + '</span>' +
              '<span class="bp-cart-pop__item-meta">' + i.quantity + ' × ' + bpMoney(i.final_line_price / i.quantity, cart.currency) + '</span>' +
            '</div>' +
          '</div>';
        }).join('');
        // popust na razini košarice (kod za popust ili automatski popust na narudžbu) nije u cijeni linije,
        // pa ga pokaži zasebno da kupac vidi da je kod primijenjen
        var apps = cart.cart_level_discount_applications || [];
        if (apps.length && cart.total_price < cart.items_subtotal_price) {
          var off = 0, names = [];
          apps.forEach(function (a) { off += a.total_allocated_amount || 0; if (a.title) names.push(a.title); });
          if (off > 0) list.innerHTML += '<div class="bp-cart-pop__item" style="display:flex;justify-content:space-between;gap:12px;font-size:.9rem;opacity:.85">' +
            '<span>Popust ' + names.join(', ') + ' (−' + bpMoney(off, cart.currency) + ')</span><strong>Ukupno ' + bpMoney(cart.total_price, cart.currency) + '</strong></div>';
        }
        pop.classList.add('bp-cart-pop--open');
        updateCartCount(cart.item_count);
      });
  }

  function updateCartCount(n) {
    document.querySelectorAll('.bp-header__count').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  /* ---- Poruka ispod gumba (rasprodani model u odabiru) ---- */
  function showAtcMsg(btn, text, href, label) {
    var wrap = btn.parentElement || btn;
    var m = wrap.querySelector('.bp-atc-msg');
    if (!m) {
      m = document.createElement('p');
      m.className = 'bp-atc-msg';
      m.setAttribute('role', 'alert');
      wrap.appendChild(m);
    }
    m.textContent = text;
    if (href) {
      var a = document.createElement('a');
      a.href = href; a.className = 'bp-swap-btn'; a.textContent = label || 'Otvori košaricu';
      a.style.textDecoration = 'none';
      m.appendChild(a);
    }
    m.classList.add('bp-atc-msg--show');
    clearTimeout(m._bpT);
    m._bpT = setTimeout(function () { m.classList.remove('bp-atc-msg--show'); }, href ? 15000 : 7000);
  }

  /* ---- AJAX add to cart (works with Kaching's fetch interceptor) ---- */
  function initAjaxAtc() {
    if (document.documentElement.dataset.bpAtc) return;
    document.documentElement.dataset.bpAtc = '1';
    // capture phase: runs before Kaching's own click handler, which would
    // add to cart itself and hard-redirect to /cart
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.bp-pdp__atc');
      if (!btn || btn.disabled) return;
      var form = btn.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      // rasprodani model za kupčevu državu u odabranom paketu (bp-stock-country.liquid) → ne šalji ništa
      var soldOut = window.bpStock && window.bpStock.soldOutInSelection();
      if (soldOut) {
        if (window.bpStock.onBlocked) window.bpStock.onBlocked(btn, soldOut); // + gumb "Zamijeni s X"
        else showAtcMsg(btn, 'Model ' + soldOut + ' je rasprodan. Odaberi drugi model.');
        return;
      }
      btn.classList.add('bp-atc--busy');
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) { var err = new Error('add failed'); err.status = r.status; throw err; }
          return r.json();
        })
        .then(function () {
          // gumb "Naruči" (data-bp-checkout): ravno na naplatu umjesto pop-upa košarice
          if (btn.hasAttribute('data-bp-checkout')) { btn.disabled = true; location.href = '/checkout'; return; }
          showCartPopup();
        })
        .catch(function (err) {
          // 422 = Shopify nema dovoljno zalihe za traženu količinu u državi kupca. Najčešći razlog:
          // zadnji komad modela je VEĆ u kupčevoj košarici (npr. drugi klik na isti paket).
          // Tada otvori pop-up košarice da može odmah naručiti, umjesto slijepe poruke o grešci.
          if (err && err.status === 422) {
            fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                if (cart && cart.item_count > 0) {
                  if (btn.hasAttribute('data-bp-checkout')) { location.href = '/checkout'; return; }
                  showAtcMsg(btn, 'Zadnji dostupni komadi su već u tvojoj košarici. Otvori košaricu i dovrši narudžbu.', '/cart', 'Otvori košaricu');
                  showCartPopup();
                } else {
                  showAtcMsg(btn, 'Za ovu ponudu trenutno nema dovoljno zalihe. Odaberi drugu ponudu ili model.');
                }
              })
              .catch(function () { showAtcMsg(btn, 'Za ovu ponudu trenutno nema dovoljno zalihe. Odaberi drugu ponudu ili model.'); });
            return;
          }
          // native fallback samo bez Kaching paketa: Kaching bi nakon greške dodao samo glavni
          // proizvod s bundle svojstvima (djelomični paket po sniženoj cijeni)
          if (document.querySelector('.kaching-bundles__bar input:checked')) showAtcMsg(btn, 'Dodavanje nije uspjelo. Pokušaj ponovno.');
          else form.submit();
        })
        .finally(function () { btn.classList.remove('bp-atc--busy'); });
    }, true);
  }

  function init() {
    initHeader();
    initCarousels();
    initAjaxAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
